export default __webpack_public_path__ + "assets/elcordis-component.0f5a539e.svg";